import React, { useEffect, useState, useCallback } from 'react';
import api from '../../utils/axiosConfig';
import { NavLink } from "react-router-dom";
import PreLoader from '../../Loader/PreLoader';
import { formatDateTime } from '../../helper/utils';

const NonAcademicFeeTnxList = () => {

    const [tnxList, setTnxList] = useState([]);
    const [loading, setLoading] = useState(false);
    const studentUid = sessionStorage.getItem('student_uid');

    const fetchTnxList = useCallback(async () => {
        setLoading(true);
        try {
            const response = await api.get(`/non-academic-fee-tnx-list/${studentUid}`);
            setTnxList(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [studentUid]); // ✅ dependency added

    useEffect(() => {
        fetchTnxList();
    }, [fetchTnxList]); // ✅ no warning now


    const handleDownloadNonAcaFeeReceipt = async (transactionId) => {
        try {
            const response = await api.get(
                `/download-non-academic-fee-receipt/${transactionId}`,
                {
                    responseType: 'blob', // ✅ important
                }
            );

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Receipt-${transactionId}.pdf`;
            document.body.appendChild(a);
            a.click();

            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Failed to download receipt:', error);
            alert('Failed to download receipt. Please try again.');
        }
    };

    return (
        <div className='container-fluid mt-3'>
            <div className="card shadow-sm">
                
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Non-Academic Fee Transaction List</h5>
                        <NavLink to="/finance/payment/non-academic"  className="btn btn-sm btn-outline-success">
                            Generate New Receipt
                        </NavLink>
                </div>

                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered table-hover table-striped">
                            
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Transaction ID</th>
                                    <th>Total Amount</th>
                                    <th>Term</th>
                                    <th>Year</th>
                                    <th>Status</th>
                                    <th>Generated at</th>
                                    <th>Verified date</th>
                                    <th>Verified by</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="10" className="text-center py-4">
                                            <PreLoader />
                                        </td>
                                    </tr>
                                ) : (tnxList?.length ?? 0) > 0 ? (
                                    tnxList.map((item, index) => (
                                        <tr key={item.tnx_id}>
                                            <td>{index + 1}</td>
                                            <td>{item.tnx_id}</td>
                                            <td>{item.total_amt}</td>
                                            <td>{item.term_id === 1 ? 'Spring' : 'Summer'}</td>
                                            <td>{item.year}</td>
                                            <td>
                                                <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-warning'}`}>
                                                    {item.status === 1 ? 'Paid' : 'Pending'}
                                                </span>
                                            </td>
                                            <td>{formatDateTime(item.created_at)}</td>
                                            <td>{item.verified_date || 'Not Verified'}</td>
                                            <td>{item.verified_by || 'Not Verified'}</td>
                                            <td>
                                                <button className="btn btn-sm btn-info me-2" onClick={() => handleDownloadNonAcaFeeReceipt(item.tnx_id)}>
                                                    Download
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className="text-center">
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>

                <div className="card-footer text-end">
                    <small>Total Records: {tnxList.length}</small>
                </div>

            </div>
        </div>
    )
}

export default NonAcademicFeeTnxList;